import { render } from "./img-column-full-bleed.vue?vue&type=template&id=49ab8f77&scoped=true"
import script from "./img-column-full-bleed.vue?vue&type=script&lang=js"
export * from "./img-column-full-bleed.vue?vue&type=script&lang=js"

import "./img-column-full-bleed.vue?vue&type=style&index=0&id=49ab8f77&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ab8f77"]])

export default __exports__